var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.2477L0.30684 31.9091L14.8184 10.2024L14.849 9.97261L8.45219 0.500185C7.91598 -0.293276 6.40707 -0.0926319 6.23132 0.795625L0 32.2477Z",
    fill: "#FFC24A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.181091 31.9898L0.413064 31.6331L14.7727 10.1538L8.39162 0.642898C7.86134 -0.142246 6.51459 0.0579424 6.34058 0.936856L0.181091 31.9898Z",
    fill: "#FFA712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5124 17.1378L24.2755 13.2924L19.511 6.12236C19.0588 5.44364 17.796 5.44159 17.3485 6.12236L14.8029 9.94918V10.275L19.5123 17.1378H19.5124Z",
    fill: "#F4BD62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4275 16.9777L24.0581 13.2392L19.4275 6.2882C18.9878 5.62839 17.9196 5.55923 17.4845 6.22098L14.9256 10.1073L14.849 10.306L19.4275 16.9777Z",
    fill: "#FFA50E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.248L0.139039 32.1377L0.64432 31.9759L19.2133 17.3919L19.4486 16.8871L14.8163 9.92847L0 32.248Z",
    fill: "#F6820C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1073 39.6031L36.9127 32.2146L32.1137 8.91496C31.9635 8.18599 30.8291 7.89784 30.1671 8.42047L0 32.2481L16.709 39.6025C17.2283 39.8311 17.8132 39.9512 18.4081 39.9513C19.0029 39.9514 19.5879 39.8315 20.1073 39.6031Z",
    fill: "#FDE068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7621 32.1526L31.9995 9.02993C31.8506 8.30643 30.9071 8.00711 30.2502 8.52587L0.186432 32.2028L16.712 39.4843C17.2274 39.7111 17.8078 39.8303 18.3981 39.8304C18.9884 39.8305 19.5689 39.7116 20.0845 39.485L36.7622 32.1525L36.7621 32.1526Z",
    fill: "#FCCA3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1072 39.3853C19.5878 39.6137 19.0028 39.7335 18.408 39.7334C17.8132 39.7333 17.2283 39.6133 16.709 39.3847L0.134597 32.136L0.000183105 32.248L16.709 39.6024C17.2284 39.831 17.8133 39.9511 18.4081 39.9512C19.0029 39.9513 19.5879 39.8314 20.1074 39.603L36.9127 32.2145L36.8715 32.0149L20.1074 39.3854L20.1072 39.3853Z",
    fill: "#EEAB37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.342de1fc6a3c629f193a2a794dac818a.svg";
export { ForwardRef as ReactComponent };